export default __webpack_public_path__ + "static/media/hamburger.968e74b4.svg";